import { PropsWithChildren, ReactNode } from 'react';

import { Stack, Typography } from 'libs/ui';
import { PropsWithTestAttribute } from 'types/testAttribute';

interface Props extends PropsWithChildren {
  title: string;
  headerRight?: ReactNode;
}

export const Section = ({
  title,
  headerRight,
  children,
  datax,
}: Props & PropsWithTestAttribute) => (
  <Stack as="section" datax={datax} spacing={12}>
    <Stack alignItems="center" as="header" direction="row" spacing={12}>
      <Typography as="h3" variant="subtitle">
        {title}
      </Typography>
      {headerRight}
    </Stack>
    {children}
  </Stack>
);
